import * as React from 'react'

const SendInviteIcon = (props: { className?: string }) => {
  return (
    <svg
      className={'icon ' + props.className}
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0.00833333 15L17.5 7.5L0.00833333 0L0 5.83333L12.5 7.5L0 9.16667L0.00833333 15Z'
        transform='translate(1.6665 2.5)'
        fill='#666666'
      />
    </svg>
  )
}

export default SendInviteIcon



// WEBPACK FOOTER //
// ./src/components/icons/ui/SendInvite.tsx